import { render, staticRenderFns } from "./evNavDialog.vue?vue&type=template&id=3545b36c&scoped=true"
import script from "./evNavDialog.vue?vue&type=script&lang=js"
export * from "./evNavDialog.vue?vue&type=script&lang=js"
import style0 from "./evNavDialog.vue?vue&type=style&index=0&id=3545b36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545b36c",
  null
  
)

export default component.exports